import { Button, Classes, Dialog } from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { PerfilStore } from "../../stores/perfil/PerfilStore";
import { LoginStore } from "../../stores/login/LoginStore";

interface PagamentoPendentePageProps {}

interface PagamentoPendentePageState {}

@observer
export class PagamentoPendentePage extends React.Component<
  PagamentoPendentePageProps,
  PagamentoPendentePageState
> {

  obs = observable({
    open_modal: true as boolean,
    url_plano: null as any
  })

  async componentDidMount() {
    await PerfilStore.getAssinatura();

    this.obs.url_plano = PerfilStore.obs.historico_plano;
  }

  handleLogout() {
    LoginStore.resetTokens()
    window.location.href = "/"
  }

  render() {
    let userPrincipal = AppStore.obs1.usuario ? AppStore.obs1.usuario.principal : "";

    return (
      <div>
        {userPrincipal
          ? (
            <Dialog
              isOpen={this.obs.open_modal}
              title="Detalhes da Fatura"
              style={{ width: 600, textAlign: "center" }}
            >
              <div className={Classes.DIALOG_BODY}>
                <iframe
                  src={this.obs.url_plano}
                  width="700px"
                  height="500px"
                  id="myId"
                  className="myClassname"
                />
              </div>
              <span
                style={{
                  color: "#3e6971",
                  textAlign: "center",
                  fontSize: "20px",
                }}
              >
                Evite a suspensão da sua conta, efetue o pagamento da sua fatura.
              </span>
              <span
                style={{
                  color: "#3e6971",
                  textAlign: "center",
                  fontSize: "20px",
                }}
              >
                Dúvidas entre em contato com o suporte.
              </span>

              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <Button text="Sair" intent="danger" onClick={() => this.handleLogout()} />
              </div>
            </Dialog>
          )
          : (
            <Dialog
              isOpen={this.obs.open_modal}
              title="Fatura Pendente"
              style={{ width: 600, textAlign: "center" }}
            >
              <span
                style={{
                  color: "#3e6971",
                  textAlign: "center",
                  fontSize: "20px",
                }}
              >
                Evite a suspensão da sua conta, efetue o pagamento da sua fatura.
              </span>
              <span
                style={{
                  color: "#3e6971",
                  textAlign: "center",
                  fontSize: "20px",
                }}
              >
                Dúvidas entre em contato com o suporte.
              </span>

              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <Button text="Sair" intent="danger" onClick={() => this.handleLogout()} />
              </div>
            </Dialog>
          )}
      </div>
    );
  }
}

export default PagamentoPendentePage;
